import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  useAddTodoMutation,
  useGetTodosQuery,
  useDeleteTodoMutation,
} from "../../redux/slices/productApiSlice";

import {
  useAddsTodoMutation,
  useGetsTodosQuery,
  useDeleteeTodoMutation,
} from "../../redux/slices/todoApiSlice";

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FaRegHeart,
  FaHeart,
  FaArrowLeft,
  FaArrowRight,
  FaSearch,
  FaFilter,
  FaShoppingCart,
  FaExclamationTriangle,
  FaCheckCircle,
  FaRedo,
  FaSpinner,
  FaBoxOpen,
  FaTrash,
} from "react-icons/fa";

import { useGetCatagoryQuery } from "../../redux/slices/catagoryApiSlice";
import { setCatagory } from "../../redux/slices/catagorySlice";

const Products = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /*
   * =========================================================
   * CART MUTATIONS
   * =========================================================
   */
  const [addTodo] = useAddTodoMutation();
  const [deleteTodo] = useDeleteTodoMutation();

  /*
   * =========================================================
   * FAVORITE MUTATIONS
   * =========================================================
   */
  const [addTodoo] = useAddsTodoMutation();
  const [deleteeTodo] = useDeleteeTodoMutation();

  /*
   * =========================================================
   * PRODUCTS STATE
   * =========================================================
   */
  const [products, setProducts] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedCategory, setSelectedCategory] =
    useState("all");

  const [priceRange, setPriceRange] =
    useState("all");

  const [inStock, setInStock] =
    useState("all");

  const scrollRef = useRef(null);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [productsLoading, setProductsLoading] =
    useState(true);

  const [loadMoreLoading, setLoadMoreLoading] =
    useState(false);

  const [productsError, setProductsError] =
    useState("");

  /*
   * Hazırda hansı məhsul səbətə əlavə/silinir
   */
  const [addingCartId, setAddingCartId] =
    useState(null);

  /*
   * Hazırda hansı məhsul favorite edilir/silinir
   */
  const [addingFavoriteId, setAddingFavoriteId] =
    useState(null);

  const [reloadKey, setReloadKey] = useState(0);

  /*
   * =========================================================
   * CATEGORY QUERY
   * =========================================================
   */
  const {
    data: categoryData,
    isLoading: categoryLoading,
    isError: categoryIsError,
    error: categoryError,
    refetch: refetchCategories,
  } = useGetCatagoryQuery();

  /*
   * =========================================================
   * USER
   * =========================================================
   */
  const { userInfo } = useSelector(
    (state) => state.auth
  );

  /*
   * =========================================================
   * CART - RTK QUERY
   *
   * Cart məlumatı artıq Redux productSlice-dan yox,
   * birbaşa RTK Query-dən gəlir.
   * =========================================================
   */
  const {
    data: cartData,
  } = useGetTodosQuery();

  /*
   * =========================================================
   * FAVORITES - RTK QUERY
   * =========================================================
   */
  const {
    data: favoriteData,
  } = useGetsTodosQuery();

  /*
   * =========================================================
   * NORMALIZE CART DATA
   * =========================================================
   */
  const cartItems =
    cartData?.todos ||
    cartData?.allTodos ||
    cartData ||
    [];

  /*
   * =========================================================
   * NORMALIZE FAVORITE DATA
   * =========================================================
   */
  const favoriteItems =
    favoriteData?.todos ||
    favoriteData?.allTodos ||
    favoriteData ||
    [];

  /*
   * =========================================================
   * ERROR MESSAGE
   * =========================================================
   */
  const getErrorMessage = (
    error,
    defaultMessage = "Naməlum xəta baş verdi."
  ) => {
    if (!error) return defaultMessage;

    if (typeof error === "string") {
      return error;
    }

    const serverMessage =
      error?.data?.message ||
      error?.data?.error ||
      error?.response?.data?.message ||
      error?.response?.data?.error;

    if (serverMessage) {
      return serverMessage;
    }

    if (error?.message) {
      if (error.message === "Network Error") {
        return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı və serverin işlək vəziyyətdə olduğunu yoxlayın.";
      }

      return error.message;
    }

    switch (error?.status) {
      case 400:
        return "Göndərilən məlumatlar düzgün deyil. Zəhmət olmasa, məlumatları yoxlayın.";

      case 401:
        return "Bu əməliyyatı yerinə yetirmək üçün hesabınıza daxil olmalısınız.";

      case 403:
        return "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur.";

      case 404:
        return "Sorğu edilən məlumat tapılmadı.";

      case 408:
        return "Sorğu çox gec cavablandırıldı. Zəhmət olmasa, yenidən cəhd edin.";

      case 429:
        return "Çox sayda sorğu göndərildi. Bir neçə saniyə gözləyib yenidən cəhd edin.";

      case 500:
        return "Server daxilində xəta baş verdi.";

      case 502:
        return "Server hazırda düzgün cavab vermir.";

      case 503:
        return "Server hazırda əlçatan deyil. Bir qədər sonra yenidən cəhd edin.";

      default:
        return defaultMessage;
    }
  };

  /*
   * =========================================================
   * CART / FAVORITE ITEM-DƏN PRODUCT ID GÖTÜR
   * =========================================================
   */
  const getItemProductId = (item) => {
    const productId =
      item?.productId?._id ||
      item?.productId ||
      item?.product?._id ||
      item?.qolbaq?._id ||
      item?.qolbaqId?._id ||
      item?.qolbaqId ||
      item?.qolbaq_id;

    return productId
      ? String(productId)
      : null;
  };

  /*
   * =========================================================
   * MƏHSUL SƏBƏTDƏDİR?
   * =========================================================
   */
  const isProductInCart = (productId) => {
    if (
      !Array.isArray(cartItems) ||
      !productId
    ) {
      return false;
    }

    return cartItems.some(
      (item) =>
        getItemProductId(item) ===
        String(productId)
    );
  };

  /*
   * =========================================================
   * MƏHSULUN CART RECORD-UNU TAP
   *
   * DELETE zamanı product ID yox,
   * cart record-un öz _id-si lazımdır.
   * =========================================================
   */
  const getCartItem = (productId) => {
    if (
      !Array.isArray(cartItems) ||
      !productId
    ) {
      return null;
    }

    return (
      cartItems.find(
        (item) =>
          getItemProductId(item) ===
          String(productId)
      ) || null
    );
  };

  /*
   * =========================================================
   * MƏHSUL FAVORİDƏDİR?
   * =========================================================
   */
  const isProductInFavorite = (productId) => {
    if (
      !Array.isArray(favoriteItems) ||
      !productId
    ) {
      return false;
    }

    return favoriteItems.some(
      (item) =>
        getItemProductId(item) ===
        String(productId)
    );
  };

  /*
   * =========================================================
   * CART DUPLICATE MESSAGE
   * =========================================================
   */
  const getDuplicateActionMessage = (
    error,
    type,
    productTitle
  ) => {
    const rawMessage = String(
      error?.data?.message ||
        error?.data?.error ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        ""
    ).toLocaleLowerCase("az-AZ");

    const duplicateWords = [
      "already",
      "duplicate",
      "exists",
      "artıq",
      "movcud",
      "mövcud",
      "səbət",
      "seçilmiş",
      "favori",
      "favorite",
      "favorie",
    ];

    const isDuplicateError =
      error?.status === 409 ||
      error?.response?.status === 409 ||
      duplicateWords.some((word) =>
        rawMessage.includes(word)
      );

    if (!isDuplicateError) {
      return null;
    }

    if (type === "cart") {
      return `"${productTitle}" məhsulu artıq səbətdədir.`;
    }

    return `"${productTitle}" məhsulu artıq Sevimlilərinizdədir.`;
  };

  /*
   * =========================================================
   * CATEGORY DATA -> REDUX
   * =========================================================
   */
  useEffect(() => {
    if (categoryData?.allCatagory) {
      dispatch(
        setCatagory(
          categoryData.allCatagory
        )
      );
    }
  }, [categoryData, dispatch]);

  /*
   * =========================================================
   * PRODUCTS FETCH
   * =========================================================
   */
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setProductsError("");

        if (page === 1) {
          setProductsLoading(true);
        } else {
          setLoadMoreLoading(true);
        }

        let url =
          `${process.env.REACT_APP_API_BASE_URL}/api/qolbaq`;

        if (
          userInfo &&
          userInfo._id
        ) {
          url += `/${userInfo._id}?page=${page}`;
        } else {
          url += `?page=${page}`;
        }

        const response =
          await axios.get(url);

        if (!isMounted) return;

        const newData =
          Array.isArray(
            response?.data?.allQolbaq
          )
            ? response.data.allQolbaq
            : [];

        if (page === 1) {
          setProducts(newData);
        } else {
          setProducts((prevData) => {
            const existingIds =
              new Set(
                prevData.map(
                  (item) => item?._id
                )
              );

            const uniqueNewData =
              newData.filter(
                (item) =>
                  item?._id &&
                  !existingIds.has(
                    item._id
                  )
              );

            return [
              ...prevData,
              ...uniqueNewData,
            ];
          });
        }

        const totalPages =
          Number(
            response?.data?.totalPages ||
              1
          );

        setHasMore(
          page < totalPages
        );
      } catch (error) {
        if (!isMounted) return;

        console.error(
          "Məhsullar yüklənmədi:",
          error
        );

        setProductsError(
          getErrorMessage(
            error,
            "Məhsullar yüklənərkən gözlənilməyən xəta baş verdi."
          )
        );
      } finally {
        if (!isMounted) return;

        setProductsLoading(false);
        setLoadMoreLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [
    page,
    userInfo?._id,
    reloadKey,
  ]);

  /*
   * =========================================================
   * RETRY
   * =========================================================
   */
  const handleRetryProducts = () => {
    setProductsError("");
    setProducts([]);
    setPage(1);
    setHasMore(true);
    setProductsLoading(true);
    setReloadKey(
      (prev) => prev + 1
    );
  };

  /*
   * =========================================================
   * LOAD MORE
   * =========================================================
   */
  const loadMore = () => {
    if (
      hasMore &&
      !loadMoreLoading &&
      !productsLoading
    ) {
      setPage(
        (prev) => prev + 1
      );
    }
  };

  /*
   * =========================================================
   * SƏBƏTƏ ƏLAVƏ ET / SƏBƏTDƏN SİL
   *
   * ƏSAS DƏYİŞİKLİK BURADADIR.
   *
   * Səbətdə deyilsə:
   *     ADD
   *
   * Səbətdədirsə:
   *     DELETE
   * =========================================================
   */
  const handleAddToCart = async (
    product
  ) => {
    if (!product?._id) {
      toast.error(
        "Məhsulun identifikasiya məlumatı tapılmadı. Məhsulu səbətə əlavə etmək mümkün deyil."
      );

      return;
    }

    const productId =
      String(product._id);

    const productTitle =
      product.title ||
      "Məhsul";

    /*
     * Stok yoxdursa və səbətdə deyilsə
     * əlavə etməyə icazə vermirik.
     *
     * Amma məhsul artıq səbətdədirsə,
     * stok 0 olsa belə onu silmək mümkün olmalıdır.
     */
    const isInCart =
      isProductInCart(
        productId
      );

    /*
     * Eyni anda ikinci cart əməliyyatına
     * icazə vermirik.
     */
    if (
      addingCartId !== null
    ) {
      return;
    }

    /*
     * =====================================================
     * SƏBƏTDƏDİR -> SİL
     * =====================================================
     */
    if (isInCart) {
      const cartItem =
        getCartItem(
          productId
        );

      if (!cartItem?._id) {
        toast.error(
          `"${productTitle}" məhsulunun səbət məlumatı tapılmadı. Məhsul səbətdən silinə bilmədi.`
        );

        return;
      }

      try {
        setAddingCartId(
          productId
        );

        await deleteTodo(
          cartItem._id
        ).unwrap();

        /*
         * productApiSlice:
         *
         * invalidatesTags: ["Cart"]
         *
         * olduğuna görə cartData avtomatik
         * yenilənəcək.
         */
        toast.success(
          `"${productTitle}" məhsulu səbətinizdən silindi.`
        );
      } catch (err) {
        console.error(
          "Məhsul səbətdən silinə bilmədi:",
          err
        );

        toast.error(
          `"${productTitle}" məhsulunu səbətdən silmək mümkün olmadı. Səbəb: ${getErrorMessage(
            err,
            "Server tərəfindən naməlum xəta qaytarıldı."
          )}`
        );
      } finally {
        setAddingCartId(
          null
        );
      }

      return;
    }

    /*
     * =====================================================
     * SƏBƏTDƏ DEYİL -> ƏLAVƏ ET
     * =====================================================
     */
    if (product.stock === 0) {
      toast.error(
        `"${productTitle}" hazırda stokda olmadığı üçün səbətə əlavə edilə bilməz.`
      );

      return;
    }

    try {
      setAddingCartId(
        productId
      );

      await addTodo({
        productId,
      }).unwrap();

      /*
       * ARTİQ BUNU ETMİRİK:
       *
       * dispatch({
       *   type: "product/addTodo",
       *   payload: newTodo,
       * });
       *
       * Çünki RTK Query özü Cart məlumatını
       * invalidatesTags vasitəsilə yeniləyir.
       */
      toast.success(
        `"${productTitle}" məhsulu səbətə əlavə edildi.`
      );
    } catch (err) {
      console.error(
        "Məhsul səbətə əlavə edilə bilmədi:",
        err
      );

      const duplicateMessage =
        getDuplicateActionMessage(
          err,
          "cart",
          productTitle
        );

      if (duplicateMessage) {
        toast.info(
          duplicateMessage
        );
      } else {
        toast.error(
          `"${productTitle}" məhsulunu səbətə əlavə etmək mümkün olmadı. Səbəb: ${getErrorMessage(
            err,
            "Server tərəfindən naməlum xəta qaytarıldı."
          )}`
        );
      }
    } finally {
      setAddingCartId(
        null
      );
    }
  };

  /*
   * =========================================================
   * FAVORITE TOGGLE
   *
   * AĞ ÜRƏK -> ADD
   * QIRMIZI ÜRƏK -> DELETE
   * =========================================================
   */
  const handleAddToFavorite =
    async (product) => {
      if (!product?._id) {
        toast.error(
          "Məhsulun identifikasiya məlumatı tapılmadı. Sevimlilərə əlavə etmək mümkün deyil."
        );

        return;
      }

      const productId =
        String(product._id);

      const productTitle =
        product.title ||
        "Məhsul";

      if (
        addingFavoriteId !== null
      ) {
        return;
      }

      const isFavorite =
        isProductInFavorite(
          productId
        );

      setAddingFavoriteId(
        productId
      );

      try {
        /*
         * ===================================================
         * QIRMIZI ÜRƏK -> FAVORİDƏN SİL
         * ===================================================
         */
        if (isFavorite) {
          const favoriteItem =
            favoriteItems.find(
              (item) =>
                getItemProductId(
                  item
                ) === productId
            );

          if (
            !favoriteItem?._id
          ) {
            toast.error(
              "Sevimli məhsulun məlumatı tapılmadı. Məhsul silinə bilmədi."
            );

            return;
          }

          await deleteeTodo(
            favoriteItem._id
          ).unwrap();

          toast.success(
            `"${productTitle}" məhsulu Sevimlilər siyahısından silindi.`
          );

          return;
        }

        /*
         * ===================================================
         * AĞ ÜRƏK -> FAVORİYƏ ƏLAVƏ ET
         * ===================================================
         */
        await addTodoo({
          productId,
        }).unwrap();

        toast.success(
          `"${productTitle}" məhsulu Sevimlilər siyahısına əlavə edildi.`
        );
      } catch (err) {
        console.error(
          "Sevimli məhsul əməliyyatında xəta:",
          err
        );

        const status =
          err?.status ||
          err?.response?.status;

        const rawMessage =
          String(
            err?.data?.message ||
              err?.data?.error ||
              err?.response?.data
                ?.message ||
              err?.response?.data
                ?.error ||
              err?.message ||
              ""
          ).toLocaleLowerCase(
            "az-AZ"
          );

        const isDuplicate =
          status === 409 ||
          rawMessage.includes(
            "already"
          ) ||
          rawMessage.includes(
            "duplicate"
          ) ||
          rawMessage.includes(
            "exists"
          ) ||
          rawMessage.includes(
            "artıq"
          ) ||
          rawMessage.includes(
            "artiq"
          ) ||
          rawMessage.includes(
            "mövcud"
          ) ||
          rawMessage.includes(
            "movcud"
          );

        /*
         * Duplicate favorite zamanı
         * heç bir "artıq favoridədir" toast-u göstərmirik.
         */
        if (
          !isFavorite &&
          isDuplicate
        ) {
          return;
        }

        /*
         * DELETE xətası
         */
        if (isFavorite) {
          toast.error(
            `"${productTitle}" məhsulu Sevimlilər siyahısından silmək mümkün olmadı.`
          );

          return;
        }

        /*
         * ADD xətası
         */
        toast.error(
          `"${productTitle}" məhsulunu Sevimlilərə əlavə etmək mümkün olmadı. Səbəb: ${getErrorMessage(
            err,
            "Server tərəfindən naməlum xəta qaytarıldı."
          )}`
        );
      } finally {
        setAddingFavoriteId(
          null
        );
      }
    };

  /*
   * =========================================================
   * FILTER
   * =========================================================
   */
  const filteredProducts =
    products.filter(
      (product) => {
        const matchesSearch =
          product.title
            ?.toLowerCase()
            .includes(
              searchTerm.toLowerCase()
            );

        const matchesCategory =
          selectedCategory ===
            "all" ||
          product.catagory ===
            selectedCategory;

        const matchesPrice =
          priceRange ===
            "all" ||
          (priceRange ===
            "low" &&
            product.price <=
              50) ||
          (priceRange ===
            "mid" &&
            product.price >
              50 &&
            product.price <=
              150) ||
          (priceRange ===
            "high" &&
            product.price >
              150);

        const matchesStock =
          inStock ===
            "all" ||
          (inStock ===
            "inStock" &&
            product.stock >
              0) ||
          (inStock ===
            "outOfStock" &&
            product.stock ===
              0);

        return (
          matchesSearch &&
          matchesCategory &&
          matchesPrice &&
          matchesStock
        );
      }
    );

  /*
   * =========================================================
   * SCROLL LEFT
   * =========================================================
   */
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -=
        400;
    }
  };

  /*
   * =========================================================
   * SCROLL RIGHT
   * =========================================================
   */
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft +=
        400;
    }
  };

  /*
   * =========================================================
   * RESET FILTERS
   * =========================================================
   */
  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategory(
      "all"
    );
    setPriceRange("all");
    setInStock("all");
  };

  /*
   * =========================================================
   * PRODUCT IMAGE
   * =========================================================
   */
  const getProductImage = (
    product
  ) => {
    if (
      Array.isArray(
        product?.photo
      )
    ) {
      return product.photo[0];
    }

    return product?.photo;
  };

  /*
   * =========================================================
   * PRICE FORMAT
   * =========================================================
   */
  const formatPrice = (
    price
  ) => {
    const numericPrice =
      Number(price);

    if (
      Number.isNaN(
        numericPrice
      )
    ) {
      return "0,00 ₼";
    }

    return `${numericPrice.toLocaleString(
      "az-AZ",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )} ₼`;
  };

  /*
   * =========================================================
   * ACTIVE FILTER COUNT
   * =========================================================
   */
  const activeFilterCount = [
    searchTerm,
    selectedCategory !==
      "all",
    priceRange !== "all",
    inStock !== "all",
  ].filter(Boolean).length;

  /*
   * =========================================================
   * INITIAL LOADING
   * =========================================================
   */
  if (
    productsLoading &&
    products.length === 0
  ) {
    return (
      <div className="min-h-screen bg-slate-50 px-4 py-8 dark:bg-slate-950 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">

          <div className="mb-8 overflow-hidden rounded-3xl bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-700 p-6 shadow-xl sm:p-8">

            <div className="flex items-center gap-4 text-white">

              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 backdrop-blur">
                <FaBoxOpen className="text-2xl" />
              </div>

              <div>
                <h1 className="text-2xl font-bold sm:text-3xl">
                  Məhsullar
                </h1>

                <p className="mt-1 text-sm text-white/80 sm:text-base">
                  Məhsullar yüklənir...
                </p>
              </div>

            </div>
          </div>

          <div className="flex min-h-[400px] items-center justify-center rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">

            <div className="flex flex-col items-center text-center">

              <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-50 dark:bg-indigo-950">
                <FaSpinner className="animate-spin text-2xl text-indigo-600" />
              </div>

              <h2 className="text-lg font-bold text-slate-900 dark:text-white">
                Məhsullar yüklənir...
              </h2>

              <p className="mt-2 max-w-md text-sm text-slate-500 dark:text-slate-400">
                Məhsullar hazırlanır. Zəhmət olmasa, bir qədər gözləyin.
              </p>

            </div>
          </div>

        </div>
      </div>
    );
  }

  /*
   * =========================================================
   * PRODUCT ERROR
   * =========================================================
   */
  if (
    productsError &&
    products.length === 0
  ) {
    return (
      <div className="min-h-screen bg-slate-50 px-4 py-8 dark:bg-slate-950 sm:px-6 lg:px-8">

        <div className="mx-auto flex min-h-[600px] max-w-3xl items-center justify-center">

          <div className="w-full overflow-hidden rounded-3xl border border-red-200 bg-white shadow-xl dark:border-red-900/50 dark:bg-slate-900">

            <div className="h-2 bg-gradient-to-r from-red-500 to-rose-600" />

            <div className="p-6 text-center sm:p-10">

              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-50 dark:bg-red-950/50">
                <FaExclamationTriangle className="text-2xl text-red-600" />
              </div>

              <h1 className="mt-5 text-2xl font-bold text-slate-900 dark:text-white">
                Məhsullar yüklənmədi
              </h1>

              <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
                Məhsulların yüklənməsi zamanı problem yarandı.
                Aşağıda problemin səbəbi göstərilib.
              </p>

              <div className="mt-6 rounded-2xl border border-red-200 bg-red-50 p-4 text-left dark:border-red-900/50 dark:bg-red-950/30">

                <div className="flex gap-3">

                  <FaExclamationTriangle className="mt-1 shrink-0 text-red-600" />

                  <div>

                    <p className="font-semibold text-red-800 dark:text-red-300">
                      Xətanın səbəbi
                    </p>

                    <p className="mt-1 break-words text-sm leading-6 text-red-700 dark:text-red-400">
                      {productsError}
                    </p>

                  </div>
                </div>
              </div>

              <button
                onClick={
                  handleRetryProducts
                }
                className="mt-7 inline-flex items-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 px-6 py-3 font-semibold text-white shadow-lg transition hover:scale-[1.02] hover:shadow-xl"
              >
                <FaRedo />
                Yenidən cəhd edin
              </button>

            </div>
          </div>

        </div>
      </div>
    );
  }

  /*
   * =========================================================
   * MAIN UI
   * =========================================================
   */
  return (
    <div className="min-h-screen w-full bg-slate-50 dark:bg-slate-950">

      <div className="mx-auto w-full max-w-[1600px] px-4 py-6 sm:px-6 lg:px-8">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="mb-6 overflow-hidden rounded-3xl bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-700 p-6 shadow-xl sm:p-8">

          <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">

            <div className="flex items-center gap-4 text-white">

              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/15 backdrop-blur">
                <FaBoxOpen className="text-2xl" />
              </div>

              <div>

                <h1 className="text-2xl font-bold sm:text-3xl">
                  Məhsullar
                </h1>

                <p className="mt-1 text-sm text-white/80 sm:text-base">
                  Sizə uyğun məhsulları axtarın və filtrlərdən istifadə edərək
                  daha rahat seçim edin.
                </p>

              </div>
            </div>

            <div className="rounded-2xl bg-white/10 px-5 py-3 text-white backdrop-blur">

              <p className="text-xs text-white/70">
                Göstərilən məhsullar
              </p>

              <p className="mt-1 text-xl font-bold">
                {filteredProducts.length}
              </p>

            </div>

          </div>
        </div>

        {/* =================================================
            FILTER PANEL
        ================================================= */}

        <div className="mb-7 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-6">

          <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

            <div className="flex items-center gap-3">

              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 dark:bg-indigo-950 dark:text-indigo-400">
                <FaFilter />
              </div>

              <div>

                <h2 className="font-bold text-slate-900 dark:text-white">
                  Məhsul axtarışı və filtrlər
                </h2>

                <p className="text-xs text-slate-500 dark:text-slate-400">
                  İstədiyiniz məhsulu daha asan tapın.
                </p>

              </div>

            </div>

            {activeFilterCount > 0 && (
              <button
                onClick={
                  resetFilters
                }
                className="inline-flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-600 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-indigo-950"
              >
                Filtrləri sıfırla
              </button>
            )}

          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">

            {/* SEARCH */}

            <div className="relative">

              <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

              <input
                type="text"
                placeholder="Məhsul adına görə axtarın..."
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(
                    e.target.value
                  )
                }
                className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
              />

            </div>

            {/* CATEGORY */}

            <div>

              <select
                value={
                  selectedCategory
                }
                onChange={(e) =>
                  setSelectedCategory(
                    e.target.value
                  )
                }
                disabled={
                  categoryLoading
                }
                className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
              >

                <option value="all">
                  {categoryLoading
                    ? "Kateqoriyalar yüklənir..."
                    : "Bütün kateqoriyalar"}
                </option>

                {categoryData?.allCatagory?.map(
                  (cat) => (
                    <option
                      key={cat._id}
                      value={cat.title}
                    >
                      {cat.title}
                    </option>
                  )
                )}

              </select>

            </div>

            {/* PRICE */}

            <div>

              <select
                value={priceRange}
                onChange={(e) =>
                  setPriceRange(
                    e.target.value
                  )
                }
                className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
              >

                <option value="all">
                  Bütün qiymətlər
                </option>

                <option value="low">
                  0 – 50 ₼
                </option>

                <option value="mid">
                  51 – 150 ₼
                </option>

                <option value="high">
                  151 ₼ və daha çox
                </option>

              </select>

            </div>

            {/* STOCK */}

            <div>

              <select
                value={inStock}
                onChange={(e) =>
                  setInStock(
                    e.target.value
                  )
                }
                className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
              >

                <option value="all">
                  Bütün məhsullar
                </option>

                <option value="inStock">
                  Stokda olan məhsullar
                </option>

                <option value="outOfStock">
                  Stokda olmayan məhsullar
                </option>

              </select>

            </div>

          </div>

          {/* CATEGORY ERROR */}

          {categoryIsError && (
            <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 dark:border-amber-900/50 dark:bg-amber-950/30">

              <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">

                <div className="flex gap-3">

                  <FaExclamationTriangle className="mt-0.5 shrink-0 text-amber-600" />

                  <div>

                    <p className="font-semibold text-amber-800 dark:text-amber-300">
                      Kateqoriyalar yüklənmədi
                    </p>

                    <p className="mt-1 break-words text-sm leading-6 text-amber-700 dark:text-amber-400">
                      Səbəb:{" "}
                      {getErrorMessage(
                        categoryError,
                        "Kateqoriyalar serverdən əldə edilə bilmədi."
                      )}
                    </p>

                  </div>

                </div>

                <button
                  onClick={
                    refetchCategories
                  }
                  className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-amber-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-amber-700"
                >
                  <FaRedo />
                  Yenidən cəhd edin
                </button>

              </div>
            </div>
          )}

        </div>

        {/* =================================================
            PRODUCT AREA
        ================================================= */}

        <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white py-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">

          {/* LEFT */}

          <button
            onClick={
              scrollLeft
            }
            className="absolute left-3 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-lg transition hover:scale-105 hover:bg-indigo-50 hover:text-indigo-600 dark:border-slate-700 dark:bg-slate-800 dark:text-white dark:hover:bg-indigo-950"
            aria-label="Məhsulları sola sürüşdür"
          >
            <FaArrowLeft />
          </button>

          {/* RIGHT */}

          <button
            onClick={
              scrollRight
            }
            className="absolute right-3 top-1/2 z-10 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-lg transition hover:scale-105 hover:bg-indigo-50 hover:text-indigo-600 dark:border-slate-700 dark:bg-slate-800 dark:text-white dark:hover:bg-indigo-950"
            aria-label="Məhsulları sağa sürüşdür"
          >
            <FaArrowRight />
          </button>

          <div
            ref={scrollRef}
            className="overflow-x-auto scroll-smooth px-12 pb-3"
          >

            {filteredProducts.length >
            0 ? (
              <div className="grid auto-cols-[17rem] grid-flow-col grid-rows-3 gap-5">

                {filteredProducts.map(
                  (product) => {
                    const productImage =
                      getProductImage(
                        product
                      );

                    const productId =
                      String(
                        product._id
                      );

                    /*
                     * CART STATE
                     */
                    const isAddingCart =
                      addingCartId ===
                      productId;

                    const isInCart =
                      isProductInCart(
                        productId
                      );

                    /*
                     * FAVORITE STATE
                     */
                    const isAddingFavorite =
                      addingFavoriteId ===
                      productId;

                    const isFavorite =
                      isProductInFavorite(
                        productId
                      );

                    return (
                      <div
                        key={
                          product._id
                        }
                        className={`group relative w-[17rem] overflow-hidden rounded-3xl border bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl dark:bg-slate-800 ${
                          isInCart
                            ? "border-emerald-300 dark:border-emerald-700"
                            : "border-slate-200 dark:border-slate-700"
                        }`}
                      >

                        {/* =================================================
                            CART STATUS BADGE
                        ================================================= */}

                        {isInCart && (
                          <div className="absolute left-3 top-3 z-10 flex items-center gap-1.5 rounded-full bg-emerald-500 px-3 py-1.5 text-xs font-bold text-white shadow-lg">
                            <FaCheckCircle />
                            Səbətinizdədir
                          </div>
                        )}

                        {/* =================================================
                            FAVORITE
                        ================================================= */}

                        <button
                          onClick={() =>
                            handleAddToFavorite(
                              product
                            )
                          }
                          disabled={
                            isAddingFavorite ||
                            addingFavoriteId !==
                              null
                          }
                          className={`absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 shadow-md backdrop-blur transition hover:scale-105 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-slate-900/90 ${
                            isFavorite
                              ? "text-red-500 hover:text-red-600"
                              : "text-slate-600 hover:text-red-600 dark:text-slate-200"
                          }`}
                          aria-label={
                            isFavorite
                              ? "Məhsulu Sevimlilərdən sil"
                              : "Məhsulu Sevimlilərə əlavə et"
                          }
                        >
                          {isAddingFavorite ? (
                            <FaSpinner className="animate-spin" />
                          ) : isFavorite ? (
                            <FaHeart className="text-lg" />
                          ) : (
                            <FaRegHeart className="text-lg" />
                          )}
                        </button>

                        {/* =================================================
                            IMAGE
                        ================================================= */}

                        <div className="relative overflow-hidden">

                          {productImage ? (
                            <img
                              src={
                                productImage
                              }
                              alt={
                                product.title ||
                                "Məhsul"
                              }
                              className="h-44 w-full cursor-pointer object-cover transition duration-500 group-hover:scale-105"
                              onClick={() =>
                                navigate(
                                  `/product/${product._id}`
                                )
                              }
                            />
                          ) : (
                            <div
                              onClick={() =>
                                navigate(
                                  `/product/${product._id}`
                                )
                              }
                              className="flex h-44 cursor-pointer items-center justify-center bg-slate-100 dark:bg-slate-700"
                            >

                              <div className="text-center">

                                <FaBoxOpen className="mx-auto text-3xl text-slate-400" />

                                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                                  Şəkil mövcud deyil
                                </p>

                              </div>

                            </div>
                          )}

                          {/* DISCOUNT */}

                          {product.discountApplied && (
                            <div className="absolute bottom-3 left-3 rounded-full bg-red-500 px-3 py-1 text-xs font-bold text-white shadow">
                              Endirim
                            </div>
                          )}

                          {/* OUT OF STOCK */}

                          {product.stock ===
                            0 && (
                            <div className="absolute bottom-3 right-3 rounded-full bg-slate-900/80 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                              Stokda yoxdur
                            </div>
                          )}

                        </div>

                        {/* =================================================
                            CONTENT
                        ================================================= */}

                        <div className="p-4">

                          <h3 className="truncate text-base font-bold text-slate-900 dark:text-white">
                            {product.title ||
                              "Adsız məhsul"}
                          </h3>

                          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                            Kateqoriya:{" "}
                            {product.catagory ||
                              "Kateqoriya yoxdur"}
                          </p>

                          {/* PRICE */}

                          <div className="mt-3">

                            {product.discountApplied ? (
                              <div className="flex flex-wrap items-center gap-2">

                                <span className="text-sm text-slate-400 line-through">
                                  {formatPrice(
                                    product.originalPrice
                                  )}
                                </span>

                                <span className="text-lg font-extrabold text-emerald-600">
                                  {formatPrice(
                                    product.price
                                  )}
                                </span>

                              </div>
                            ) : (
                              <span className="text-lg font-extrabold text-indigo-600 dark:text-indigo-400">
                                {formatPrice(
                                  product.price
                                )}
                              </span>
                            )}

                          </div>

                          {/* STOCK */}

                          <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                            {product.stock >
                            0
                              ? `Stokda ${product.stock} ədəd var`
                              : "Bu məhsul hazırda stokda yoxdur."}
                          </p>

                          {/* DETAIL */}

                          <button
                            onClick={() =>
                              navigate(
                                `/product/${product._id}`
                              )
                            }
                            className="mt-4 w-full rounded-xl border border-slate-200 py-2.5 text-sm font-semibold text-slate-700 transition hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-600 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-indigo-950"
                          >
                            Ətraflı bax
                          </button>

                          {/* =================================================
                              CART TOGGLE BUTTON
                          ================================================= */}

                          <button
                            onClick={() =>
                              handleAddToCart(
                                product
                              )
                            }
                            disabled={
                              isAddingCart ||
                              addingCartId !==
                                null ||
                              (!isInCart &&
                                product.stock ===
                                  0)
                            }
                            className={`mt-2 flex w-full items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-bold transition disabled:cursor-not-allowed disabled:opacity-70 ${
                              isInCart
                                ? "border border-emerald-300 bg-emerald-50 text-emerald-700 shadow-sm hover:border-red-300 hover:bg-red-50 hover:text-red-600 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-400 dark:hover:border-red-800 dark:hover:bg-red-950/40 dark:hover:text-red-400"
                                : product.stock ===
                                  0
                                ? "bg-slate-400 text-white"
                                : isAddingCart
                                ? "cursor-wait bg-indigo-400 text-white"
                                : "bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-md hover:from-indigo-700 hover:to-violet-700"
                            }`}
                          >

                            {isAddingCart ? (
                              <>
                                <FaSpinner className="animate-spin" />

                                {isInCart
                                  ? "Səbətdən silinir..."
                                  : "Səbətə əlavə edilir..."}
                              </>
                            ) : isInCart ? (
                              <>
                                <FaTrash />

                                <span className="flex flex-col items-center leading-tight">
                                  <span>
                                    Səbətinizdədir
                                  </span>

                                  <span className="text-[10px] font-medium opacity-70">
                                    Silmək üçün toxunun
                                  </span>
                                </span>
                              </>
                            ) : product.stock ===
                              0 ? (
                              <>
                                <FaShoppingCart />
                                Stokda yoxdur
                              </>
                            ) : (
                              <>
                                <FaShoppingCart />
                                Səbətə əlavə et
                              </>
                            )}

                          </button>

                        </div>
                      </div>
                    );
                  }
                )}

              </div>
            ) : (
              <div className="flex min-h-[380px] items-center justify-center">

                <div className="px-6 text-center">

                  <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800">
                    <FaBoxOpen className="text-2xl text-slate-400" />
                  </div>

                  <h2 className="mt-5 text-xl font-bold text-slate-900 dark:text-white">
                    Məhsul tapılmadı
                  </h2>

                  <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-500 dark:text-slate-400">
                    Seçdiyiniz axtarış və filtr şərtlərinə uyğun məhsul yoxdur.
                  </p>

                  {activeFilterCount >
                    0 && (
                    <button
                      onClick={
                        resetFilters
                      }
                      className="mt-5 rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-700"
                    >
                      Filtrləri sıfırla
                    </button>
                  )}

                </div>
              </div>
            )}

          </div>

          {/* LOAD MORE */}

          {hasMore &&
            filteredProducts.length >
              0 && (
              <div className="mt-6 flex flex-col items-center px-5">

                <button
                  onClick={
                    loadMore
                  }
                  disabled={
                    loadMoreLoading ||
                    productsLoading
                  }
                  className="inline-flex min-w-[220px] items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 px-6 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02] hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:scale-100"
                >

                  {loadMoreLoading ? (
                    <>
                      <FaSpinner className="animate-spin" />
                      Məhsullar yüklənir...
                    </>
                  ) : (
                    <>
                      <FaArrowRight />
                      Daha çox məhsul göstər
                    </>
                  )}

                </button>

                {loadMoreLoading && (
                  <p className="mt-3 text-xs text-slate-500 dark:text-slate-400">
                    Yeni məhsullar gətirilir. Zəhmət olmasa, gözləyin...
                  </p>
                )}

              </div>
            )}

          {/* NO MORE */}

          {!hasMore &&
            products.length >
              0 && (
              <div className="mt-6 flex justify-center px-5">

                <div className="flex items-center gap-2 rounded-full bg-slate-100 px-5 py-2.5 text-sm font-medium text-slate-500 dark:bg-slate-800 dark:text-slate-400">

                  <FaCheckCircle className="text-emerald-500" />

                  Bütün məhsullar göstərildi.

                </div>

              </div>
            )}

        </div>

        {/* BACKGROUND LOADING */}

        {productsLoading &&
          products.length >
            0 && (
            <div className="mt-5 flex items-center justify-center gap-3 rounded-2xl border border-indigo-100 bg-indigo-50 p-4 text-sm text-indigo-700 dark:border-indigo-900/50 dark:bg-indigo-950/30 dark:text-indigo-300">

              <FaSpinner className="animate-spin" />

              Məhsullar yenilənir. Zəhmət olmasa, gözləyin...

            </div>
          )}

      </div>
    </div>
  );
};

export default Products;
